import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store";
import AppContentContainer from '@/views/AppContentContainer.vue'
//import Main from '@/views/Main.vue'
import Cards from '@/views/Cards.vue'
//import Discount from '@/views/Discount.vue'
import Tickets from '@/views/Tickets.vue'
import Discount from '@/views/Discount.vue'
import Requests from '@/views/Requests.vue'
import Offer from '@/views/Offer.vue'
//import Bill from '@/views/Bill.vue'
//import Waybill from '@/views/Waybill.vue'
//import Invoice from '@/views/Invoice.vue'
import NotFound from "@/views/NotFound.vue"

Vue.use(VueRouter)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next();
    return;
  }
  next("/");
};

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next();
    return;
  }
  next("/login");
};

const ifAuthenticatedAndWorkOrdersEnabled = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next("/login");
    return
  }
  //console.log('isAuthenticated ' + store.getters.isAuthenticated);
  if (store.getters.isWorkOrdersEnabled) {    
    //console.log('isWorkOrdersEnabled ' + store.getters.isWorkOrdersEnabled);
    //console.log(to);
    //console.log(from);
    next();
    return;
  }
  else {
    //console.log('isWorkOrdersEnabled ' + store.getters.isWorkOrdersEnabled);
    //console.log(to);
    //console.log(from);
    next(from);  
  }
};
const ifAuthenticatedAndExternalOrdersEnabled = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next("/login");
    return
  }
  if (store.getters.isWorkExternalOrdersEnabled) {    
    next();
    return;
  }
  else {
    next(from);  
  }
};

// Если не залогинен, то редиректит на страницу логина и возвращает true, иначе возвращает false
const redirectToLoginIfNotAuthenticated = (next) => {
  if (!store.getters.isAuthenticated) {
    next("/login");
    return true;
  }

  return false;
}

// Сначала проверяет авторизованность, а затем отправляет на страницу назначения,
// если переданный параметр condition = true, иначе оставляет на той же странице
const checkAuthAndBool = (to, from, next, condition) => {
  if(!redirectToLoginIfNotAuthenticated(next)){
    console.log('condition',condition);
    if(condition){
      next();
    }
    else{
      next(from);
    }
  }
}

const routes = [
  {
    path: '/',
    component: AppContentContainer,
    children: [
      /*{
        path: '',
        component: !ifDriver ? Main : () => import('@/views/UserMain.vue'),
        beforeEnter: ifAuthenticated
      },*/
      {
        path: '',
        component: function () {
          if (store.getters.isDriver){
            return import('@/views/UserMain.vue')
          }else{
            return import('@/views/Main.vue')
          }
        },  
        beforeEnter: ifAuthenticated
      },
      {
        path: '/driver',
        component: () => import('@/views/UserMain.vue'),
        beforeEnter: ifAuthenticated
      }, 


      {
        path: 'cards',
        component: Cards,
        beforeEnter: (to, from, next) => checkAuthAndBool(to, from, next, store.getters.isFuelCardsEnabled),
      },
      {
        path: 'cards/details',
        component: () => import(/* webpackChunkName: "cardsDetails" */ '@/views/CardsTransactions.vue'),
        beforeEnter: (to, from, next) => checkAuthAndBool(to, from, next, store.getters.isFuelCardsEnabled),
      },
      {
        path: 'cards/:id',
        component: () => import(/* webpackChunkName: "cardEdit" */ '@/views/CardEdit.vue'),
        beforeEnter: (to, from, next) => checkAuthAndBool(to, from, next, store.getters.isFuelCardsEnabled),
      },
      {
        path: 'tickets',
        component: Tickets,
        beforeEnter: (to, from, next) => checkAuthAndBool(to, from, next, store.getters.isTicketsEnabled),
      },
      {
        path: 'tickets/details',
        component: () => import(/* webpackChunkName: "ticketsDetails" */ '@/views/TicketsDetails.vue'),
        beforeEnter: (to, from, next) => checkAuthAndBool(to, from, next, store.getters.isTicketsEnabled),
      },
      {
        path: 'discount',
        component: Discount,
        beforeEnter: (to, from, next) => checkAuthAndBool(to, from, next, store.getters.isDiscountCardsEnabled),
      },
      {
        path: 'requests',
        component: Requests,
        beforeEnter: (to, from, next) => checkAuthAndBool(to, from, next, store.getters.isRequestsEnabled),
      },
      /*{
        path: 'bills',
        component: Bill,
        beforeEnter: ifAuthenticated,
      },
      {
        path: 'waybills',
        component: Waybill,
        beforeEnter: ifAuthenticated,
      },
      {
        path: 'invoices',
        component: Invoice,
        beforeEnter: ifAuthenticated,
      },*/
      {
        path: 'profile',
        component: () => import(/* webpackChunkName: "profile" */ '../views/Profile.vue'),
        beforeEnter: ifAuthenticated,
      },
      {
        path: 'orders',
        component: () => import(/* webpackChunkName: "orders" */ '../views/Orders.vue'),
        beforeEnter: ifAuthenticatedAndExternalOrdersEnabled,
      },
     {
        path: 'orders/new',
        component: () => import(/* webpackChunkName: "orders" */ '../views/NewOrder.vue'),
        beforeEnter: ifAuthenticatedAndExternalOrdersEnabled,
      },
      {
        path: 'workorders',
        component: () => import(/* webpackChunkName: "orders" */ '../views/Workorders.vue'),
        beforeEnter: ifAuthenticatedAndWorkOrdersEnabled,
      },
      {
        path: 'workorder/:id',
        component: () => import('@/views/WorkorderEdit.vue'),
        beforeEnter: ifAuthenticatedAndWorkOrdersEnabled,
      },
    ]
  },
  {
    path: '/register',
    component: () => import(/* webpackChunkName: "register" */ '../views/Register.vue'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/recover',
    component: () => import(/* webpackChunkName: "recover" */ '../views/Recover.vue'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/offer',
    component: Offer,
  },
  { path: '*', component: NotFound }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
